<template>
  <div v-if="notification" :class="classes">
    <p>{{ notification.message }}</p>
    <span class="btn btn-sm btn-secondary" @click="cleanNotification">{{ $t('close') }}</span>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  methods: {
    ...mapActions(['cleanNotification'])
  },
  computed: {
    ...mapGetters({
      notification: 'getNotification'
    }),
    classes () {
      return {
        'dx-notification': true,
        'dx-notification--error': this.notification.type === 'error',
        'dx-notification--info': this.notification.type === 'info',
        'dx-notification--success': this.notification.type === 'success',
        'dx-notification--warning': this.notification.type === 'warning'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/DxNotification.vue